import { render, staticRenderFns } from "./adverseReactionDetail.vue?vue&type=template&id=20dbff74&scoped=true&"
import script from "./adverseReactionDetail.vue?vue&type=script&lang=js&"
export * from "./adverseReactionDetail.vue?vue&type=script&lang=js&"
import style0 from "./adverseReactionDetail.vue?vue&type=style&index=0&id=20dbff74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dbff74",
  null
  
)

export default component.exports